const LOGO_URL = "/img/logo.jpg";

export default function SchoolHeader() {
  return (
    <header
      data-testid="school-header"
      className="w-full eis-header text-white"
    >
      <div className="max-w-7xl mx-auto px-3 md:px-6 py-3 md:py-4 flex items-center gap-3 md:gap-4">
        <img
          src={LOGO_URL}
          alt="EIS Logo"
          className="h-16 w-16 md:h-20 md:w-20 rounded-lg object-cover flex-shrink-0 shadow"
        />
        <div className="flex-1 min-w-0">
          <h1 className="text-xl md:text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight">
            EUREKA INTERNATIONAL SCHOOL
          </h1>
          <div className="text-[11px] md:text-sm font-semibold mt-1 leading-tight text-white/95">
            <p>Shree Control Chowk Rd, Dhayari, Pune, Maharashtra 411041</p>
            <p>+91 7276600034 / +91 9022955376</p>
            <p className="truncate">schooleurekainternational@gmail.com</p>
          </div>
        </div>
        <div className="hidden md:block text-right flex-shrink-0">
          <p className="text-sm md:text-base font-semibold">
            CBSE Affiliation No. 1131508
          </p>
        </div>
      </div>
    </header>
  );
}
